import { Box, Dialog, Divider } from "@mui/material";
import { createElement, useEffect, useState } from "react";
import get_cid from "../lib/get_cid";
import get_center from "../lib/get_center";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { cloneElement } from "react";

function WhatsNewDetail({ children, data }) {
  const [open, setOpen] = useState(false);
  const router = useHistory();

  console.log(data);

  return (
    <>
      <Dialog fullScreen open={open} onClose={() => setOpen(false)}>
        <section className="p-[30px_0_10px_10px]">
          <img
            src="/img/back_button_black.png"
            onClick={() => setOpen(false)}
          />
        </section>
        <section className="font-bold p-[20px] border-y">{data.sub_text}</section>
        <section className="relative mt-3">
          <img src={data.body_img} width="100%" />
          {data.meta_bodyimg.map((item, index) => (
            <button
              className="absolute"
              style={{
                height: item.height + "%",
                width: item.width + "%",
                top: item.top + "%",
                left: item.left + "%",
              }}
              key={index}
              onClick={() => {
                item.url && router.push(item.url);
              }}
            />
          ))}
        </section>
      </Dialog>

      {cloneElement(children, { onClick: () => setOpen(true) })}
    </>
  );
}

export default WhatsNewDetail;
